<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <!-- <headers active_screen="activity" header="Activity" /> -->
        <navbar active_screen="activity" />
        <template v-if="$device == 'mobile'">
            <template v-if="ine(activities)">
                <v-infinite-scroll :loading="getting_data" @bottom="nextPage" style="overflow-y: scroll; overflow-x: hidden">
                    <div style="margin: 12px; padding: 2px; background-color: #fff; padding-bottom: 24px; border-radius: 15px" v-for="(activity, activity_index) in activities" :key="activity_index" @click="r('/activity-detail', { act_id: activity.act_id })">
                        <center>
                            <img :src="activity.image" style="width: 100%; margin: 0 auto; border-radius: 15px 15px 0 0" />
                        </center>
                        <div class="row">
                            <div class="col-11">
                                <label class="title fs-20">
                                    {{ activity.title }}
                                </label>
                            </div>
                            <div class="col-1 mt-8">
                                <img @click="toggleFavorite($event, activity)" v-if="activity.button_favorite" src="../../../public/resources/images/icon-star.png" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                                <img @click="toggleFavorite($event, activity)" v-if="!activity.button_favorite" src="../../../public/resources/images/icon-star-select.png" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                            </div>
                        </div>
                        <div style="justify-content: space-between; display: flex">
                            <label class="description fs-16">
                                {{ activity.act_day }}
                            </label>
                        </div>
                    </div>
                </v-infinite-scroll>
            </template>
            <div v-else class="text-center" style="display: flex; height: 100vh; justify-content: center; padding-bottom: 120px">
                <div style="margin: auto 0; position: relative; padding: 16px; border-radius: 1rem">
                    <label class="data-not-found-label"> ยังไม่มีรายการ Activity ในขณะนี้ </label>
                </div>
            </div>
        </template>
        <template v-else>
            <template v-if="ine(activities_2d)">
                <v-infinite-scroll :loading="getting_data" @bottom="nextPage" style="overflow-y: scroll; overflow-x: hidden">
                    <div class="row" style="margin: 8px; background-color: #fff; padding-bottom: 24px" v-for="(col, rowIndex) in activities_2d" :key="'row_' + rowIndex">
                        <div class="col-6" style="padding: 2px; background-color: #fff" v-for="(activity, activity_index) in col" :key="'col_' + activity_index" @click="r('/activity-detail', { act_id: activity.act_id })">
                            <center>
                                <img :src="activity.image" style="width: 75%; margin: 0 auto" />
                            </center>
                            <label class="title fs-20">
                                {{ activity.title }}
                            </label>
                            <div style="justify-content: space-between; display: flex">
                                <label class="description fs-16">
                                    {{ activity.act_day }}
                                </label>
                                <img @click="toggleFavorite($event, activity)" v-if="activity.button_favorite" src="../../../public/resources/images/icon-star.png" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                                <img @click="toggleFavorite($event, activity)" v-if="!activity.button_favorite" src="../../../public/resources/images/icon-star-select.png" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                            </div>
                        </div>
                    </div>
                </v-infinite-scroll>
            </template>
            <div v-else class="text-center" style="display: flex; height: 100vh; justify-content: center; padding-bottom: 120px">
                <div style="margin: auto 0; position: relative; padding: 16px; border-radius: 1rem">
                    <label class="data-not-found-label"> ยังไม่มีรายการ Activity ในขณะนี้ </label>
                </div>
            </div>
        </template>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
        <!-- <navbar active_screen="activity" /> -->
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            activities: [],
            getting_data: true,
            current_page: 1,
            last_page: 0,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        nextPage() {
            if (this.current_page < this.last_page) {
                ++this.current_page;
                this.getActivity();
            }
        },
        _mounted: function () {
            this.getActivity(() => (this.getting_data = false));
        },
        getActivity: function (callback = null, current_page = null) {
            if (typeof current_page != 'number') current_page = this.current_page;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/activity/index',
                    data: {
                        page: current_page,
                        per_page: 20,
                    },
                    callback: (res) => {
                        if (res && res.data) {
                            this.last_page = res.last_page;
                            res.data.forEach((v, k) => {
                                var check_dup = this.activities.filter((v1) => v1.act_id == v.act_id);
                                if (check_dup.length == 0) {
                                    this.activities.push(v);
                                } else {
                                    this.activities = res.data;
                                }
                            });
                            this.activities.forEach((act, key) => {
                                act.act_day = act.act_day.replace(/↵/g, '<br/>');
                            });
                            this.activities_2d = this.atg(this.activities, 2);
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(e, activity) {
            event.stopPropagation();
            var url;
            if (!activity.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: activity.act_id,
                        type: 'activity',
                    },
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            this.getActivity();
                        } else {
                            const complete = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    complete.title += value[0];
                                }
                            }
                            this.$confirm({
                                title: complete.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
    },
};
</script>
<style scoped>
.title {
    font-weight: 600;
    margin: 8px 0 0 16px;
    color: #cc0000 !important;
    /* display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; */
}
.description {
    font-weight: 300;
    margin: 0 0 0 16px;
    color: #000 !important;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* -webkit-box-orient: vertical; */
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    white-space: pre-line;
}
</style>